import Icon from "@components/ui/icon";
import Popover from "@components/ui/popover";
import { cn } from "@lib/cn";
import { useMemo, useState } from "react";
import { OPTIONS_CONFIG } from "../constants";
import { useAiImageStore } from "../store";
import { AiImageColorsSelect } from "./ai-image-colors-select";
import { AiImageSelect } from "./ai-image-select";
import { AiImageStyleSelect } from "./ai-image-style-select";

export const AiImagesSettingsOptions = () => {
  const [isOpen, setIsOpen] = useState(false);
  const type = useAiImageStore((s) => s.type);
  const config = useMemo(
    () => OPTIONS_CONFIG[type as keyof typeof OPTIONS_CONFIG],
    [type],
  );

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <Popover.Trigger
        className={cn(
          "tw-size-8 tw-cursor-pointer tw-flex tw-items-center tw-justify-center tw-rounded-full hover:tw-bg-blue-50 tw-transition-colors",
          {
            "tw-bg-blue-50": isOpen,
          },
        )}
      >
        <Icon icon="ri-equalizer-2-line" className="tw-text-blue-800" />
      </Popover.Trigger>
      <Popover.Content className="tw-p-1 tw-space-y-0.5 tw-w-64 tw-rounded-xl tw-z-[99999] tw-bg-white tw-shadow-popover tw-border tw-border-solid tw-border-blue/5">
        {config && "layouts" in config && (
          <AiImageSelect
            label="Layout"
            options={config.layouts}
            type="layouts"
            default="centered"
            placement="nested"
          />
        )}
        {config && "aspectRatios" in config && (
          <AiImageSelect
            options={config.aspectRatios}
            type="aspectRatios"
            label="Aspect Ratio"
            default="vertical"
            placement="nested"
          />
        )}
        {config && "variants" in config && (
          <AiImageSelect
            options={config.variants}
            type="variants"
            label="Variant"
            default="flow-process"
            placement="nested"
          />
        )}
        {config && "views" in config && (
          <AiImageSelect
            options={config.views}
            type="views"
            label="View"
            default="3d-render"
            placement="nested"
          />
        )}
        {config && "backgrounds" in config && (
          <AiImageSelect
            options={config.backgrounds}
            type="backgrounds"
            label="Background"
            default="white"
            placement="nested"
          />
        )}
        {config && "styles" in config && (
          <AiImageStyleSelect options={config.styles} />
        )}
        <AiImageColorsSelect />
      </Popover.Content>
    </Popover>
  );
};
